import type { JSX } from 'react'
import type { ISkeletonUnitProps } from '../../SkeletonUnit'

import { getValueForBreakpoint } from 'utils/helpers'
import { useClientWidth } from 'utils/hooks'
import { SkeletonUnit } from '../../SkeletonUnit'
import { SkeletonUnitCorners } from '../../SkeletonUnit.h'
import { breakpointsMarginChannelLogo } from './breakpoints'

export interface IChannelLogoSkeletonUnitProps extends ISkeletonUnitProps {
  breakpointsMargin?: {}
}

export const ChannelLogoSkeletonUnit = ({
  width = '56px',
  height = '56px',
  corners = SkeletonUnitCorners.CORNERS_ROUND,
  breakpointsMargin = breakpointsMarginChannelLogo,
  ...rest
}: IChannelLogoSkeletonUnitProps): JSX.Element => {
  const clientWidth = useClientWidth()
  const validMargin = breakpointsMargin
    ? getValueForBreakpoint(clientWidth, breakpointsMargin)
    : rest.margins

  return (
    <SkeletonUnit
      width={width}
      height={height}
      corners={corners}
      margins={validMargin}
      {...rest}
    />
  )
}
